import type { ChainFamily } from 'src/blockchain';
import type { PurchaseChainOption } from 'src/utils/purchaseChains';

/**
 * Which wallet family the payment modal must offer to connect, or `null` when it must offer
 * nothing.
 *
 * The modal is the only place in the app that can ask: every other connect button takes the
 * default family (TRON), and the profile's per-family button exists only while that family's slot
 * is still empty. So a buyer who has linked their EVM wallet — the only buyer allowed to pay on
 * Base — had nowhere to connect it, and the payment was unreachable no matter what they clicked.
 *
 * The answer is the family of the *selected network*, not the default one: what the buyer needs to
 * connect is decided by where the money is about to move.
 */
export function walletConnectPromptFamily(
  selected: Pick<PurchaseChainOption, 'family'> | undefined,
  isLinkedWalletConnected: boolean
): ChainFamily | null {
  if (!selected || isLinkedWalletConnected) {
    return null;
  }

  return selected.family;
}
